<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/newtable'
import { ErrorWrapper } from '@utils/error-handler'
import {
  reportComputed,
  reportListMethod,
  authComputed,
  collegeComputed,
  collegeListMethod,
  siteListMethod,
} from '@state/helpers'
import { COLLEGE_ROLE } from '@utils/constant'
export default {
  page: {
    title: 'Report List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, Table },
  data() {
    return {
      COLLEGE_ROLE: COLLEGE_ROLE,
      isLoading: true,
      reportlist: {},
      allReportList: {},
      collegelist: [],
      collegeId: 'All',
      platformId: 'All',
      isUserAdmin: false,
      siteconfiglist: [],
      allCollegeList: [],
      fields: [
        {
          value: 'title',
          text: ' Report Title',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'description',
          text: 'Report Description',
          sortable: true,
          colType: 'default',
          width: '50%',
        },
        {
          value: 'type',
          text: 'Type',
          sortable: true,
          colType: 'default',
        },

        {
          value: 'action1',
          text: 'Action(s)',
          sortable: false,
          colType: 'button',
        },
      ],
      displayFields: [
        { key: 'name', label: 'Name', colType: 'default' },
        { key: 'platform_id', label: 'Platform Id', colType: 'default' },
      ],
    }
  },
  computed: {
    ...authComputed,
    ...reportComputed,
    ...collegeComputed,
  },
  mounted() {
    this.getListOfPlatform()
    this.getListOfReports()
    this.getColleges()
  },
  methods: {
    ...reportListMethod,
    ...collegeListMethod,
    ...siteListMethod,
    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    getColleges() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          college.docs.forEach((element) => {
            var ele = {}
            ele.text = element.name
            ele.value = element._id
            ele.platform_id = element.platform_id
            listitems.push(ele)
          })
          this.collegelist = listitems
          this.allCollegeList = listitems
        })
        .catch((_error) => {})
    },

    getReports() {
      if (this.collegeId !== 'All') {
        let listitems = []
        this.allReportList.docs.forEach((element) => {
          if (element.college_id === this.collegeId) {
            listitems.push(element)
          }
        })
        this.reportlist.docs = listitems
      } else {
        if (this.role !== 'admin') {
          this.reportlist.docs = this.allReportList.docs
        } else {
          let listitems = []
          this.allReportList.docs.forEach((element) => {
            if (element.platform_id === this.platformId) {
              listitems.push(element)
            }
          })
          this.reportlist.docs = listitems
        }
      }
    },

    getPlatformColleges() {
      this.collegeId = 'All'
      this.isUserAdmin = true
      let listitems = []
      listitems.push({ value: 'All', text: 'All' })
      this.allCollegeList.forEach((element) => {
        if (element.platform_id === Number(this.platformId)) {
          listitems.push(element)
        }
      })
      this.collegelist = listitems
      if (this.platformId !== 'All') {
        let listitems = []
        this.allReportList.docs.forEach((element) => {
          if (element.platform_id === Number(this.platformId)) {
            listitems.push(element)
          }
        })
        this.reportlist.docs = listitems
      } else {
        this.reportlist.docs = this.allReportList.docs
      }
    },

    // Get list of all reports role wise
    getListOfReports() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 3000,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchReportList({ filter })
        .then((reportList) => {
          this.reportlist = JSON.parse(JSON.stringify(reportList))
          this.allReportList = JSON.parse(JSON.stringify(reportList))
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            <!--<router-link
              tag="button"
              to="/dynamicreport"
              class="btn btn-info mb-2"
            >
              <span> Dynamic Report</span>
            </router-link> -->
            <br /><br />
            <b-form-group
              v-if="role === 'admin'"
              label="Select Platform"
              label-for="input-1"
            >
              <b-form-select
                v-model="platformId"
                :options="siteconfiglist"
                style="width: 50%"
                @change="getPlatformColleges"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              v-if="
                (role === 'admin' && isUserAdmin) || role === 'administrator'
              "
              label="Select College"
              label-for="input-1"
            >
              <b-form-select
                v-model="collegeId"
                :options="collegelist"
                style="width: 50%"
                @change="getReports"
              ></b-form-select>
            </b-form-group>
            <Table
              :items="reportlist ? reportlist.docs : []"
              :fields="fields"
              :bordered="true"
              :viewbtn="true"
              :downloadbtn="true"
              :updatebtn="true"
              :uploadbtn="true"
              :editbtn="false"
            ></Table>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
